import _ from "lodash";
import { useRef, useState } from "react";
import { isApiSupportedInBrowser } from "Utils";
import { useMount } from "Utils/CustomHooks";

const useViewportSize = () => {
  const [viewportSize, setViewportSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const observerRef = useRef(null);

  useMount(() => {
    if (isApiSupportedInBrowser("ResizeObserver")) {
      const updateViewportSize = entries => {
        const firstEntry = _.first(entries);
        const { width, height } = firstEntry.contentRect;
        setViewportSize({ width, height });
      };

      const debouncedUpdateViewportSize = _.debounce(updateViewportSize, 1000);
      observerRef.current = new ResizeObserver(debouncedUpdateViewportSize);
      observerRef.current.observe(document.documentElement);

      return () => {
        observerRef.current.disconnect();
      };
    } else {
      const handleResize = () => {
        setViewportSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      const debouncedHandleResize = _.debounce(handleResize, 1000);
      window.addEventListener("resize", debouncedHandleResize);

      return () => {
        window.removeEventListener("resize", debouncedHandleResize);
      };
    }
  }, []);

  return viewportSize;
};

export default useViewportSize;
